import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AbLoginFormModule} from './components/ab-login-form/ab-login-form.module';
import { AbRouterMenuModule} from './components/ab-router-menu/ab-router-menu.module';
// import { APP_BASE_LIB_COMPONENTS } from './angular/components';
// import { APP_BASE_LIB_DIRECTIVES } from './angular/directives';
import { APP_BASE_LIB_PIPES } from './pipes/index';
import { APP_BASE_LIB_SERVICES, APP_BASE_SERVICES, APP_BASE_LIB_RESOLVERS } from './services/index';
// import { APP_BASE_LIB_MODULES} from './angular/modules/index';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AbLoginFormModule,
        AbRouterMenuModule,
        // APP_BASE_LIB_MODULES
    ],
    declarations: [
       // APP_BASE_LIB_COMPONENTS,
       // APP_BASE_LIB_DIRECTIVES,
       APP_BASE_LIB_PIPES,
        // AbRouterMenuComponent
    ],
    exports: [
        // APP_BASE_LIB_COMPONENTS,
       // APP_BASE_LIB_DIRECTIVES,
        APP_BASE_LIB_PIPES,
        // APP_BASE_LIB_MODULES,
        AbLoginFormModule,
        AbRouterMenuModule
    ],
    providers: [
        APP_BASE_LIB_RESOLVERS,
        APP_BASE_LIB_SERVICES,
        APP_BASE_SERVICES
    ]
})
// export class AppBaseLibraryModule { }
export class AppBaseLibraryModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AppBaseLibraryModule
        };
    }
}


//
// import { NgModule, ModuleWithProviders } from '@angular/core';
// import { HttpModule } from '@angular/http';
// import { HttpClientModule } from '@angular/common/http';
//
// import { APP_BASE_LIB_DIRECTIVES } from '../directives';
// import { APP_BASE_LIB_PIPES } from '../pipes/index';
// import { APP_BASE_LIB_SERVICES } from '../services/index';
// import { APP_BASE_LIB_RESOLVERS } from '../services/index';
// import { APP_BASE_SERVICES } from '../services';
//
// @NgModule({
//     imports: [
//         HttpModule,
//         HttpClientModule,
//     ],
//     declarations: [
//         APP_BASE_LIB_DIRECTIVES,
//         APP_BASE_LIB_PIPES
//     ],
//     exports: [
//         APP_BASE_LIB_DIRECTIVES,
//         APP_BASE_LIB_PIPES,
//     ],
//     providers: [
//         APP_BASE_LIB_SERVICES,
//         APP_BASE_LIB_RESOLVERS,
//         APP_BASE_SERVICES
//     ]
// })
// export class AppBaseLibModule {
//
//     static forRoot(): ModuleWithProviders {
//         return {
//             ngModule: AppBaseLibModule
//         };
//     }
//
// }
